import { render, staticRenderFns } from "./details.form.vue?vue&type=template&id=712f3854&"
import script from "./details.form.vue?vue&type=script&lang=ts&"
export * from "./details.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports